import { render } from "./GalleryDesignStudy.vue?vue&type=template&id=18ab1a2e&scoped=true"
import script from "./GalleryDesignStudy.vue?vue&type=script&lang=js"
export * from "./GalleryDesignStudy.vue?vue&type=script&lang=js"

import "./GalleryDesignStudy.vue?vue&type=style&index=0&id=18ab1a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ab1a2e"]])

export default __exports__